import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useImpoundScheduleForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Impound Schedule',
        fields: [
          {
            title: 'Initial Impound Balance',
            name: 'initial_impound',
            type: 'currency',
            required: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useImpoundScheduleForm;
